// extracted by mini-css-extract-plugin
module.exports = {"sections":"search-SearchSections__sections--1CdMM"};